import { ToneDto, ToneDtoImpl } from '../tonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class ListLikeToneBuilder
{
    constructor(private likedToneList: any)
    {
        if(likedToneList.likedToneList === undefined)
        {
            throw new NoDataException("List like tone data doesnt exists");
        }
    }

    buildAll(): ToneDto[]
    {
        return this.parseLikeToneListDetailsResponse();
    }
    
    private parseLikeToneListDetailsResponse(): ToneDto[]
    {
        let listOfLikedTone: ToneDto[] = [];
        
        let toneDto = null;
        this.likedToneList.likedToneList.forEach((likedToneItem: any) =>
        {
            toneDto = new ToneDtoImpl();
            toneDto.setId(likedToneItem.toneId);
            toneDto.setCategoryId(likedToneItem.categoryId);
            
            listOfLikedTone.push(toneDto);
        });
        return listOfLikedTone;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listliketone/listliketonebuilder.ts